import {SlaEditorBaseErrorsEnum} from '../../../../editors/slaEditor/slaEditorErrors';
import {RuleEditorErrorsEnum} from '../../ruleEditorErrors';

export type SlaEditorErrorsEnum =
  // TODO change when decoupled from rule editor
  RuleEditorErrorsEnum | SlaEditorBaseErrorsEnum;

export const SlaEditorErrorsEnum = {
  // TODO change when decoupled from rule editor
  ...RuleEditorErrorsEnum,
  ...SlaEditorBaseErrorsEnum,
};
